import { get, cloneDeep, orderBy, round, removeKey } from '@/helpers';
import Vue from 'vue';

// import store from '@/store';
// import router from '@/router';
// import NestedSet from '@/nested-set-lib';

import ShopApi from '@/extensions/shop/store/api/shop';
// import { findPrice } from '@/filters';

// initial state
const state = {
    messages: [],
    cart: {
        initialised: false,
        articlePivots: [],
        qty: 0,
        tax: 0,
        sum: 0
    },
    visibleProducts: [],
    focusedMedia: null,
    customer: undefined, // TODO: null
    // categories: undefined, // TODO: null
    widescreen: undefined
};

// getters
const getters = {
    products: state => state.products,
    messages: state => state.messages,
    cart: state => state.cart,
    customer: state => state.customer,
    activeProduct: state => {
        let activeProduct = null;
        if (state.visibleProducts && state.visibleProducts.length) {
            const sorted = orderBy(state.visibleProducts, 'position', 'asc');
            activeProduct = sorted[0];
        }

        return activeProduct;
    },
    focusedMedia: state => state.focusedMedia,
    categories: state => state.categories,
    defaultCustomerGroup: (state, getters, rootState, rootGetters) => {
        return get(rootGetters, 'CMS.shop.defaultCustomerGroup');
    },
    defaultTax: (state, getters, rootState, rootGetters) => {
        return get(rootGetters, 'CMS.shop.defaultTax');
    },
    widescreen: state => state.widescreen
};

// mutations
const mutations = {
    // insertProducts(state, { products }) {
    //   // let pagination = {
    //   //     pageInfo: Object.freeze(products.pageInfo),
    //   //     items: []
    //   // };
    //   // if (products.items && products.items.length) {
    //   //     products.items.forEach((item, i) => {
    //   //         item.position = i + 1;
    //   //         const product = Object.freeze(item);
    //   //         pagination.items.push(product);
    //   //     });
    //   // }
    //   // Vue.set(state, 'products', pagination);

    //   if (products.items && products.items.length) {
    //     products.items.forEach((product, i) => {
    //       product.position = i + 1;
    //     });
    //   }
    //   // Vue.set(state, 'products', Object.freeze(products));
    //   Vue.set(state, 'products', products);
    // },
    // insertCategories(state, categories) {
    //   Vue.set(state, 'categories', Object.freeze(categories));
    // },
    // initCart(state, member) {
    //     if (!state.cart.initialised) {
    //         if (member) {
    //             let customer, cartArticles = undefined;
    //             customer = get(member, 'customer');

    //             if (customer) {
    //                 Vue.set(state, 'customer', customer);
    //             }
    //             cartArticles = get(customer, 'shoppingCart.articles');

    //             if (cartArticles && cartArticles.length) {
    //                 Vue.set(state.cart, 'articles', cartArticles);
    //             } else {
    //                 let localStorageItems = JSON.parse(localStorage.getItem('cart'));
    //                 if (localStorageItems && localStorageItems.length) {
    //                     Vue.set(state.cart, 'articles', localStorageItems.articles);
    //                 }
    //             }
    //             Vue.set(state.cart, 'initialised', true);
    //         }
    //     }
    // },
    setCustomer(state, customer) {
        Vue.set(state, 'customer', Object.freeze(customer));
    },
    setCart(state, cart) {
        // check availability of all articlePivots
        // if stock !== null (manageStock)
        // update `available` and `qty_at_limit`

        if (cart.articlePivots && cart.articlePivots.length) {
            let qtyMap = {};
            cart.articlePivots.forEach(articlePivot => {
                if (!qtyMap[articlePivot.article.id]) {
                    qtyMap[articlePivot.article.id] = {
                        stock: articlePivot.stock,
                        cart: 0
                    };
                }

                qtyMap[articlePivot.article.id].cart += articlePivot.qty;
            });

            cart.articlePivots.forEach(articlePivot => {
                if (articlePivot.stock !== null) {
                    articlePivot.available =
                        qtyMap[articlePivot.article.id].stock >= qtyMap[articlePivot.article.id].cart;
                    articlePivot.qty_at_limit =
                        qtyMap[articlePivot.article.id].stock === qtyMap[articlePivot.article.id].cart;
                }
            });
        }
        Vue.set(state, 'cart', cart);
    },
    setCartInitialised(state, status) {
        Vue.set(state.cart, 'initialised', status);
    },
    // updateCart(state, articles) {
    //     // Vue.set(state.cart, 'articles', Object.freeze(articles));
    //
    //     ShopApi.saveShoppingCartLocal(articles);
    //     ShopApi.debouncedSaveShoppingCart(articles);
    //
    //     // if (articles.length > 0) {
    //     //     let qty = 0;
    //     //     each(articles, article => {
    //     //         qty = qty + parseInt(article.pivot.qty);
    //     //     });
    //     //     Vue.set(state.cart, 'qty', qty);
    //     // }
    // },
    // clearCart(state) {
    //     Vue.set(state, 'cart', { articles: [], initialised: true });
    // },
    addVisibleProduct(state, product) {
        if (!state.visibleProducts.find(el => el.id === product.id)) {
            const length = state.visibleProducts.length;
            Vue.set(state.visibleProducts, length, product);
        }
    },
    removeVisibleProduct(state, product) {
        const i = state.visibleProducts.findIndex(el => el.id === product.id);
        if (i >= 0) Vue.delete(state.visibleProducts, i);
    },
    clearVisibleProducts(state) {
        Vue.set(state, 'visibleProducts', []);
    },
    setFocusedMedia(state, { product, media }) {
        if (media && media.type) {
            product = cloneDeep(product);
            delete product.media;

            media.product = product;
            state.focusedMedia = media;
        } else {
            state.focusedMedia = null;
        }
    },
    removeFocusedMedia(state) {
        state.focusedMedia = null;
    },
    addArticleToProduct(state, { product, articles }) {
        let products = get(state.products, 'items') || [];
        const i = products.findIndex(el => el.id === product);
        if (i >= 0) {
            Vue.set(state.products.items[i], 'articles', articles);
            Vue.set(state.products.items, i, Object.freeze(state.products.items[i]));
        }
    },
    setWidescreen(state, widescreen) {
        Vue.set(state, 'widescreen', widescreen);
    }
};

// actions
const actions = {
    fetchProductsPaginated(context, payload) {
        return ShopApi.fetchProductsPaginated(payload);
    },
    fetchProductsWithArticlesPaginated(context, payload) {
        return ShopApi.fetchProductsPaginated(payload, true);
    },
    fetchProduct(context, payload) {
        return ShopApi.fetchProduct(payload);
    },
    saveCart({ state, rootGetters }) {
        ShopApi.saveShoppingCartLocal(state.cart.articlePivots);

        if (rootGetters['auth/isAuthenticated']) {
            const articlePivots = removeKey(cloneDeep(state.cart.articlePivots), '__typename');
            ShopApi.debouncedSaveShoppingCart(articlePivots);
            // .then(cart => {
            //   // save locally and add to state
            //   ShopApi.saveShoppingCartLocal(cart.articlePivots);
            //   commit('setCart', cart);
            // });
        }
    },
    createPurchase({ dispatch }, payload) {
        return ShopApi.createPurchase(payload).then(() => dispatch('clearCart'));
    },
    // fetchCategories(context, payload) {
    //   return ShopApi.fetchCategories(payload);
    // },
    fetchProductArticles(context, product) {
        return ShopApi.fetchArticles({ product });
        // .then(articles => {
        //   // find product in pagination
        //   // and add the articles to it
        //   commit('addArticleToProduct', { product, articles });
        // });
    },
    addArticleToCart({ commit, dispatch, state, getters }, payload) {
        const article = payload.article;
        if (!article) throw new Error('missing article');

        let qty = payload.qty || 1;

        let propertyValues = [];
        let productPropertyValues = [];

        if (payload.propertyValues) propertyValues = payload.propertyValues;
        else if (payload.productPropertyValues) productPropertyValues = payload.productPropertyValues;

        if (!propertyValues.length) {
            article.propertyPivots.forEach(pivot => propertyValues.push({ id: pivot.value.id }));
            if (productPropertyValues.length) productPropertyValues.forEach(id => propertyValues.push({ id }));

            if (!propertyValues.length) throw new Error('missing property values');
        }

        // handle selectable product properties
        let articlePivots = cloneDeep(state.cart.articlePivots) || [];
        const index = articlePivots.findIndex(el => {
            const diff = el.propertyValues.filter(value => !propertyValues.some(v => v.id === value.id));
            return el.article.id === article.id && !diff.length;
        });

        // TODO
        // check if manageStock
        // and if qty fits

        if (index >= 0) {
            articlePivots[index].qty += qty;
        } else {
            articlePivots.push({
                article: { id: article.id },
                propertyValues,
                qty
            });
        }

        // const defaultCustomerGroup = get(getters, 'defaultCustomerGroup');
        const defaultTax = get(getters, 'defaultTax');
        // const customer = get(state, 'customer');

        const price = article.price;
        // findPrice(article, customer, defaultCustomerGroup, true) ||
        // findPrice(article.product, customer, defaultCustomerGroup, true);

        const taxRate = get(price, 'tax.value') || defaultTax.value;
        const tax = round((price.value * taxRate) / (100 + taxRate), 2);

        const cart = {
            qty: state.cart.qty + qty,
            sum: state.cart.sum + price.value,
            tax: state.cart.tax + tax,
            articlePivots
        };

        commit('setCart', cart);
        dispatch('saveCart');
    },
    removeArticleFromCart({ commit, dispatch, state, getters }, payload) {
        const article = payload.article;
        if (!article) throw new Error('missing article');

        let qty = payload.qty || 1;

        let propertyValues = [];
        let productPropertyValues = [];

        if (payload.propertyValues) propertyValues = payload.propertyValues;
        else if (payload.productPropertyValues) productPropertyValues = payload.productPropertyValues;

        if (!propertyValues.length) {
            article.propertyPivots.forEach(pivot => propertyValues.push({ id: pivot.value.id }));
            if (productPropertyValues.length) productPropertyValues.forEach(id => propertyValues.push({ id }));

            if (!propertyValues.length) throw new Error('missing property values');
        }

        // handle selectable product properties
        let articlePivots = cloneDeep(state.cart.articlePivots) || [];
        const index = articlePivots.findIndex(el => {
            const diff = el.propertyValues.filter(value => !propertyValues.some(v => v.id === value.id));
            return el.article.id === article.id && !diff.length;
        });

        if (index >= 0) {
            qty = Math.min(qty, articlePivots[index].qty);
            articlePivots[index].qty -= qty;

            if (articlePivots[index].qty <= 0) articlePivots.splice(index, 1);

            // const defaultCustomerGroup = get(getters, 'defaultCustomerGroup');
            const defaultTax = get(getters, 'defaultTax');
            // const customer = get(state, 'customer');

            const price = article.price;
            // findPrice(article, customer, defaultCustomerGroup, true) ||
            // findPrice(article.product, customer, defaultCustomerGroup, true);

            const taxRate = get(price, 'tax.value') || defaultTax.value;
            const tax = round((price.value * taxRate) / (100 + taxRate), 2);

            const cart = {
                qty: state.cart.qty - qty,
                sum: state.cart.sum - price.value,
                tax: state.cart.tax - tax,
                articlePivots
            };

            commit('setCart', cart);
            dispatch('saveCart');
        }
    },
    updateArticleQtyInCart({ commit, dispatch, state, getters }, payload) {
        const article = payload.article;
        if (!article) throw new Error('missing article');

        let qty = payload.qty;

        let propertyValues = [];
        let productPropertyValues = [];

        if (payload.propertyValues) propertyValues = payload.propertyValues;
        else if (payload.productPropertyValues) productPropertyValues = payload.productPropertyValues;

        if (!propertyValues.length) {
            article.propertyPivots.forEach(pivot => propertyValues.push({ id: pivot.value.id }));
            if (productPropertyValues.length) productPropertyValues.forEach(id => propertyValues.push({ id }));

            if (!propertyValues.length) throw new Error('missing property values');
        }

        // handle selectable product properties
        let articlePivots = cloneDeep(state.cart.articlePivots) || [];
        const index = articlePivots.findIndex(el => {
            const diff = el.propertyValues.filter(value => !propertyValues.some(v => v.id === value.id));
            return el.article.id === article.id && !diff.length;
        });

        qty = parseInt(qty);
        if (isNaN(qty)) qty = 0;
        else if (qty > 1000) qty = 1000;

        let q = qty;
        if (index >= 0) {
            q = qty - articlePivots[index].qty;
            articlePivots[index].qty = qty;

            if (articlePivots[index].qty <= 0) articlePivots.splice(index, 1);
        } else if (qty > 0) {
            articlePivots.push({
                article: { id: article.id },
                propertyValues,
                qty
            });
        }

        // const defaultCustomerGroup = get(getters, 'defaultCustomerGroup');
        const defaultTax = get(getters, 'defaultTax');
        // const customer = get(state, 'customer');

        const price = article.price;
        // findPrice(article, customer, defaultCustomerGroup, true) ||
        // findPrice(article.product, customer, defaultCustomerGroup, true);

        const taxRate = get(price, 'tax.value') || defaultTax.value;
        const tax = round((price.value * taxRate) / (100 + taxRate), 2);

        const cart = {
            qty: state.cart.qty + q,
            sum: state.cart.sum + price.value * q,
            tax: state.cart.tax + tax * q,
            articlePivots
        };

        commit('setCart', cart);
        dispatch('saveCart');
    },
    initCart(context, member = null) {
        const { commit, rootGetters, state } = context;

        if (!state.cart.initialised) {
            const customer = get(member, 'customer');
            if (customer) commit('setCustomer', customer);

            const articlePivots = ShopApi.getShoppingCartLocal();
            const data = get(customer, 'shoppingCart');

            // if member is logged in
            // get data from customer
            if (data && data.articlePivots && data.articlePivots.length) {
                const cart = {
                    sum: get(data, 'sum') || 0,
                    qty: get(data, 'qty') || 0,
                    tax: get(data, 'tax') || 0,
                    articlePivots: removeKey(cloneDeep(data.articlePivots), '__typename')
                };
                commit('setCart', cart);
                ShopApi.saveShoppingCartLocal(cart.articlePivots);
            }

            // otherwise initialise shopping cart by local values
            else if (articlePivots && articlePivots.length) {
                ShopApi.fetchShoppingCart(articlePivots).then(data => {
                    const cart = {
                        sum: get(data, 'sum') || 0,
                        qty: get(data, 'qty') || 0,
                        tax: get(data, 'tax') || 0,
                        articlePivots: removeKey(cloneDeep(data.articlePivots), '__typename')
                    };
                    commit('setCart', cart);

                    // if is authenticated
                    // and server returned no cart for customer
                    // but there are articles in the guest cart
                    // add the guest cart articles to the customer cart
                    // save the customer cart
                    // and clear the guest cart
                    if (rootGetters['auth/isAuthenticated']) {
                        ShopApi.saveShoppingCart(cart.articlePivots);
                        // ShopApi.saveShoppingCartLocal([], 'guest');
                    }

                    ShopApi.saveShoppingCartLocal(cart.articlePivots);
                });
            }

            commit('setCartInitialised', true);
        }
    },
    clearCart({ commit, dispatch }) {
        commit('setCart', {
            articlePivots: [],
            qty: 0,
            sum: 0,
            tax: 0
        });
        dispatch('saveCart');
    }
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
};
